import React from 'react';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { GridExportButton } from '@instinet-analytics/semantic-ui-components';
import OutliersColumnPicker from 'widgets/outliers/components/grid/OutliersGridColumnPicker';
import './OutliersGridToolbar.scss';
import { OutliersConfigState } from 'widgets/outliers/store/config/OutliersConfigState';
import { HideUnhideButton } from 'utils/components/HideUnhideButton/HideUnhideButton';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface OutliersToolbarProps {
    selectedOrderIds: string[];
    onlyShowSelected: boolean;
    onOnlyShowSelectedChanged: (next: boolean) => void;
    gridApi?: GridApi;
}

export function OutliersGridToolbar(props: OutliersToolbarProps) {
    const {
        gridApi,
        onlyShowSelected,
        onOnlyShowSelectedChanged,
        selectedOrderIds,
    } = props;

    const { editedColumnNames } = useWidgetEditedColumnNames();

    const handleToggleHidden = () => {
        onOnlyShowSelectedChanged(!onlyShowSelected);
        return true;
    };

    return (
        <WidgetToolbarShowHidePanel<OutliersConfigState>
            mustShow={false}
            propertyName={'hideGridToolbar'}
        >
            <div className="OutliersGridToolbar panel-header">
                <WidgetToolbar
                    fixedItems={
                        <>
                            {selectedOrderIds.length > 0 && (
                                <HideUnhideButton
                                    hidden={onlyShowSelected}
                                    hideTootip={'Only show selected order'}
                                    showTooltip={'Show all orders'}
                                    onClick={handleToggleHidden}
                                />
                            )}
                            <GridExportButton
                                csvFileName={'Outliers'}
                                gridApi={gridApi}
                                editedColumnNames={editedColumnNames}
                            />
                            <OutliersColumnPicker />
                        </>
                    }
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
